import BotBuilderHero from '../components/GetStarted/BotBuilderHero';
import Questions from '../components/Common/Questions';
import { Apps } from 'constants/global';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import PromotionalBanner from '../components/Common/PromotionalBanner';
import { X } from 'lucide-react';
import { useState } from 'react';

const GetStarted = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const [showHelpBanner, setShowHelpBanner] = useState(true);

  const loginLinks = (
    <>
      {' '}<Link to="/auth/login" className="underline font-semibold">login</Link> or <Link to="/auth/register" className="underline font-semibold">sign up</Link> to create your new bot
    </>
  );

  return (
    <main className="bg-background-main text-text-primary sm:rounded-md overflow-y-auto">
      <div className="w-full">
        {/* login banner */}
        {!isAuthenticated && (
          <PromotionalBanner 
            message="Please"
            actionComponent={loginLinks}
            dismissible={true}
            textSize="sm"
          />
        )}
        
        {/* help banner */}
        {/* {showHelpBanner && (
        <div className="w-full bg-black px-4 py-3 flex justify-between items-center">
          <p className="text-[14px] font-normal text-white text-center flex-1">
            Need help? Scroll down to our FAQs for detailed answers and guidance on using Bot Builder.
          </p>
          <button 
            onClick={() => setShowHelpBanner(false)} 
            className="text-white hover:text-gray-300"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        )} */}

        <BotBuilderHero isAuthenticated={isAuthenticated} />

        <Questions appType={Apps.BOT_BUILDER} />
      </div>
    </main>
  );
};

export default GetStarted;
